import { apiClient } from "./useApi"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const phinExceptionsTag = { type: ApiTag.Phin, id: `exceptions` } as const
const phinEndpoints = (build: McoEndpointBuilder) => ({
	phinGetDigests: build.query({
		queryFn: (_: void) => apiClient.extracts.phin.getDigests(),
		providesTags: (result) => [
			ApiTag.Tenant,
			{ type: ApiTag.Phin, id: "digests/all" },
			...(result?.map((r) => ({
				type: ApiTag.Phin,
				id: `digests/${r.createDate}`
			})) ?? [])
		]
	}),
	phinUndoDigest: build.mutation({
		queryFn: apiClient.extracts.phin.undoDigest,
		invalidatesTags: (_, __, createDate) => [
			{ type: ApiTag.Phin, id: `digests/${createDate}` }
		]
	}),
	phinExceptionGetFileDates: build.query({
		queryFn: (_: void) => apiClient.extracts.phin.getExceptionFileDates(),
		providesTags: [
			ApiTag.Tenant,
			phinExceptionsTag,
			{ type: ApiTag.Phin, id: `exception/filedates/all` }
		]
	}),
	phinExceptionGetTypes: build.query({
		queryFn: apiClient.extracts.phin.getExceptionTypes,
		providesTags: [
			ApiTag.Tenant,
			phinExceptionsTag,
			{ type: ApiTag.Phin, id: `exception/types/all` }
		]
	}),
	phinExceptionsGet: build.query({
		queryFn: apiClient.extracts.phin.getExceptions,
		providesTags: [
			ApiTag.Tenant,
			phinExceptionsTag,
			{ type: ApiTag.Phin, id: `exceptions/all` }
		]
	}),
	phinExceptionGetReport: build.query({
		queryFn: apiClient.extracts.phin.getExceptionReport,
		providesTags: [
			ApiTag.Tenant,
			phinExceptionsTag,
			{ type: ApiTag.Phin, id: `exceptions/report/all` }
		]
	}),
	phinExceptionDeleteAll: build.mutation({
		queryFn: (_: void) => apiClient.extracts.phin.deleteExceptions(),
		invalidatesTags: [phinExceptionsTag]
	}),
	phinExceptionUpload: build.mutation({
		queryFn: apiClient.extracts.phin.uploadExceptions,
		invalidatesTags: [phinExceptionsTag]
	})
})

export default phinEndpoints
